function tw_share(url, status) {
    var w = 600;
    var h = 300;
    var left = Number((screen.width / 2) - (w / 2));
    var top = Number((screen.height / 2) - (h / 2));
    window.open(
        'https://twitter.com/home?status=' + status + '%20' + encodeURIComponent(url),
        'twitter-share-dialog',
        'width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
    return false;
}

function linkedin_share(url, title) {
    var w = 600;
    var h = 450;
    var left = Number((screen.width / 2) - (w / 2));
    var top = Number((screen.height / 2) - (h / 2));
    window.open(
        'http://www.linkedin.com/shareArticle?mini=true&url=' + encodeURIComponent(url) + '&title=' + encodeURIComponent(title),
        'linkedin-share-dialog',
        'width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
    return false;
}

function googleplus_share(url, title) {
    var w = 600;
    var h = 450;
    var left = Number((screen.width / 2) - (w / 2));
    var top = Number((screen.height / 2) - (h / 2));
    window.open(
        'https://plus.google.com/share?url=' + encodeURIComponent(url),
        'share-dialog',
        'width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
    return false;
}

function fb_share(url) {
    var w = 600;
    var h = 300;
    var left = Number((screen.width / 2) - (w / 2));
    var top = Number((screen.height / 2) - (h / 2));
    window.open(
        'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url),
        'facebook-share-dialog',
        'width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
    return false;
}

function draugiem_share(url, title) {
    var w = 600;
    var h = 300;
    var left = Number((screen.width / 2) - (w / 2));
    var top = Number((screen.height / 2) - (h / 2));
    window.open(
        'https://www.draugiem.lv/say/ext/add.php?title=' + title + '&link=' + encodeURIComponent(url) + '&text=&titlePrefix=',
        'share-dialog',
        'width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
    return false;
}